import "@/App.css";
import { Header } from "./components/Header";
import { HeroSection } from "./components/HeroSection";
import { CompanyIntro } from "./components/CompanyIntro";
import { UseCases } from "./components/UseCases";
import { SolutionAreas } from "./components/SolutionAreas";
import { IndustryProducts } from "./components/IndustryProducts";
import { HowWeWork } from "./components/HowWeWork";
import { WhyPyrtex } from "./components/WhyPyrtex";
import { CTASection } from "./components/CTASection";
import { ContactForm } from "./components/ContactForm";
import { Footer } from "./components/Footer";
import { OnePager } from "./components/OnePager";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <HeroSection />
        <CompanyIntro />
        <UseCases />
        <SolutionAreas />
        <IndustryProducts />
        <HowWeWork />
        <WhyPyrtex />
        <CTASection />
        <ContactForm />
      </main>
      <Footer />
      <OnePager />
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
